import { ApplicationRef, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MustMatch } from './must-match.validator'; // Custom validator
import { LoginLayoutService } from '../../layouts/login-layout/login-layout.service';
import { CommonService } from '../../shared/common.service';
import { StorageService } from '../../shared/storage.service';
import { UserLayoutService } from '../../layouts/user-layout/user-layout.service';
import { HttpClient } from '@angular/common/http';
const countryData = require('../country-code.json');

@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.css']
})
export class SignUpComponent implements OnInit {
  signUpForm: FormGroup;
  submitted = false;
  errorMessage: string = '';
  showPassword = false;
  showConfirmPassword = false;
  countries: any[] = [];
  passwordCriteria = {
    minLength: false,
    upperCase: false,
    lowerCase: false,
    number: false,
    specialChar: false,
  };
  countryData = countryData;

  showPopup = false;
  isPasswordValid = false;


  constructor(
    private cdr: ChangeDetectorRef,
    private fb: FormBuilder,
    private router: Router,
    public commonService: CommonService,
    public loginLayoutService: LoginLayoutService,
    public storageService: StorageService,
    private http: HttpClient,
    private appRef: ApplicationRef,
  ) { }

  ngOnInit(): void {
    this.signUpForm = this.fb.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      email: ['', [Validators.required, this.customEmailValidator()]],
      mobilenumber: ['', [Validators.required, Validators.pattern(/^\d{10}$/)]],
      countrycode: ['+1', [Validators.required]],
      password: ['', [Validators.required, Validators.minLength(8)]],
      confirmPassword: ['', Validators.required]
    }, {
      validator: MustMatch('password', 'confirmPassword')
    });
    this.fetchCountries();
  }

  customEmailValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      const isValidEmail = emailPattern.test(control.value);
      return isValidEmail ? null : { 'invalidEmail': true };
    };
  }

  validatePassword() {
    const value = this.signUpForm.get('password')?.value || '';
    this.passwordCriteria.minLength = value.length >= 8;
    this.passwordCriteria.upperCase = /[A-Z]/.test(value);
    this.passwordCriteria.lowerCase = /[a-z]/.test(value);
    this.passwordCriteria.number = /[0-9]/.test(value);
    this.passwordCriteria.specialChar = /[@$!%*?&#^(){}[\]]/.test(value);

    this.isPasswordValid = this.allCriteriaMet();

    if (this.isPasswordValid) {
      this.showPopup = false;
    }

    // if (this.allCriteriaMet()) {
    //   this.showPopup = false;
    // }
  
    // console.log('Validation Status:', this.passwordCriteria);
    // Force a change detection cycle
    this.appRef.tick();
  }

  //showPopup = true;

  // Hide popup
  hidePopup() {
    this.showPopup = false;
  }

  allCriteriaMet(): boolean {
    return (
      this.passwordCriteria.minLength &&
      this.passwordCriteria.upperCase &&
      this.passwordCriteria.lowerCase &&
      this.passwordCriteria.number &&
      this.passwordCriteria.specialChar
    );
  }

  focusPasswordInput(): void {
    if (!this.isPasswordValid) {
      this.showPopup = true;
    }
  }
  

  fetchCountries() {
    this.http.get<any[]>('https://restcountries.com/v3.1/all').subscribe(
      (data) => {
        this.countries = data.map((country) => {
          return {
            name: country.name.common,
            dialCode: `${country.idd?.root}${country.idd?.suffixes ? country.idd.suffixes[0] : ''}`,
            flag: country.flags.png,
          };
        });
      },
      (error) => {
        console.error('Error fetching country data', error);
        this.errorMessage = "Unable to fetch country codes. Please try again later.";
      }
    );
  }

  mobilenumberInput(event: any, formName: string, controlName: string): void {
    const input = event.target;

    // Allow only numeric values (0-9)
    input.value = input.value.replace(/[^0-9]/g, '');

    // Update the form control value
    this[formName].patchValue({
      [controlName]: input.value || null,
    });
  }

  searchByName(term: string, item: any): boolean {
    term = term.toLowerCase();
    return item.name.toLowerCase().includes(term) || item.dial_code.toLowerCase().includes(term) || item.code.toLowerCase().includes(term);
  }
  

  onAlphabeticInput(event: any): void {
    const input = event.target;
    input.value = input.value.replace(/[^A-Za-z ]/g, '');
  }

  trimWhitespace(event: any): void {
    const input = event.target;
    input.value = input.value.trim();
  }

  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }

  toggleConfirmPasswordVisibility(): void {
    this.showConfirmPassword = !this.showConfirmPassword;
  }

  get f() {
    return this.signUpForm.controls;
  }

  onSubmit() {
    // console.log("onsubmit");
    this.submitted = true;

    // if (this.signUpForm.invalid) {
    //   console.log("return")
    //   return;
    // }

    const signUpData = this.signUpForm.value;

    if (this.signUpForm.valid){
      this.loginLayoutService.signUp(signUpData).subscribe(
        (Response: any) => {
          if (Response.code === 1) {
            this.commonService.notifier.notify('success', Response.message);
            this.storageService.setValue('userData', JSON.stringify(Response.data));
            this.router.navigate(['otp-verification']);
          } else {
            this.commonService.notifier.notify('error', Response.message);
          }
        },
        (error) => {
          console.error("API Error:", error);
          // this.errorMessage = "Something went wrong. Please try again.";
          // this.commonService.notifier.notify('error', this.errorMessage);
        }
      );
    }

  }
}
